import React from "react";

function LocationCard({ imageSrc, name, hours, address }) {

  return (
    <div className={`flex flex-col px-3 py-3 mx-auto w-full rounded-3xl shadow-lg bg-[#F8F8F8] border border-gray-200  max-sm:px-2 max-sm:py-2 max-sm:rounded-xl `}>
      <img
        loading="lazy"
        src={imageSrc}
        alt={`${name} location`}
        className="object-cover w-full rounded-xl aspect-[1.35] max-sm:rounded-lg"
      />
      <div className="flex flex-col justify-between flex-grow mt-4 max-sm:mt-2">
        <div className="flex justify-between items-center">
          <h2 className="md:text-[23.69px] sm:text-[11px] text-[11px] body font-bold leading-[22.3px] text-zinc-800 truncate">
            {name}
          </h2>
          {/* <p className="my-auto md:text-xl leading-loose text-[#C97C2A] sm:text-[11px] body text-[11px]">
            {hours}
          </p> */}
        </div>
        <p className="mt-2.5 md:text-[16.4px] sm:text-[11px] text-[11px] body md:leading-6 text-stone-800 max-md:mr-1.5 truncate-2-lines">
          {address}
        </p>
      </div>
    </div>
  );
}

export default LocationCard;
